// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/reversals-report/reversals-report.less
// module id = 3968
// module chunks = 0